enum NavCorporateTv {
  CAMPAIGNS = '1',
  PLAYLISTS = '2',
  MEDIAS = '3',
  EXTERNAL_URL = '4',
  EXTERNAL_NEWS = '5',
  INTERNAL_NEWS = '6'
}

export default NavCorporateTv;
